class BESSAppProjectPublishReport extends BESSAppBase {

    constructor() {
        super();
        this.reportContentAsync = $('.async-load-report-content');
        this.publishBtn = $('.app-btn-publish');
        this.publishBtn.bindClickEvent(this, this.#onPublish);
        this.publishModal = new BESSAppModal('app-publish-project-modal');
        this.confirmPublishBtn = $('.btn-confirm-publish-report');
        this.confirmPublishBtn.bindClickEvent(this, this.#onConfirmPublish);
    }

    start() {
        this.api = BESSApp.instance.services.api.project.report;
    }

    #onPublish() {
        if (!this.publishBtn.hasClass('disabled')) {
            this.publishBtn.addClass('disabled');
            this.api.reportStatus(true, this.#checkOkayToPublish.bind(this));
        }
    }

    #checkOkayToPublish(reportStatusData) {
        if (!reportStatusData.completeness.complete) {
            let warningHtml = '<p>Your BESS assessment is incomplete because:</p><ul>';
            for (let i = 0; i < reportStatusData.completeness.failed_sections.length; i++) {
                let categoryName = reportStatusData.completeness.failed_sections[i];
                warningHtml += '<li> You have not achieved a pass in the ' + categoryName + ' Category</li>';
            }
            if (!reportStatusData.completeness.docs_complete) {
                warningHtml += '<li>  You have not submitted all the required Documents and Evidence</li>';
            }
            warningHtml += '</ul><p>Are you sure you want to publish your BESS report?</p>';
            this.askUserToConfirm(
                'Publish',
                warningHtml,
                function () {
                    this.#generateOrLoadReport(reportStatusData);
                }.bind(this),
                "Yes - Publish this project",
                "No",
                this.#endPublishing.bind(this),
            )
        } else {
            this.#generateOrLoadReport(reportStatusData);
        }
    }

    #endPublishing() {
        this.publishBtn.removeClass('disabled');
    }

    #generateOrLoadReport(result) {
        if (result.report != null) {
            this.#goToReport(result.report);
        } else {
            this.reportContentAsync.ajaxLoadMe();
            this.showDoingWork(
                'Generating your report PDF',
                'Please wait whilst your document is generated.'
            );
            this.#startGenerating();
        }
    }

    #startGenerating() {
        if (!this.#hasReportLoaded()) {
            this.doDelayed(this.#startGenerating, 500);
            return;
        }

        this.doDelayed(function () {
            this.api.prepareReport(this.#monitorStatus.bind(this));
        }, 1000);
    }

    #monitorStatus(result) {
        if (result.charts === 0 && result.report != null) {
            this.#onReadyToPublish();
        } else {
            this.doDelayed(this.#checkStatus, 3000);
        }
    }


    #monitorStatusTimeout() {
        this.doDelayed(this.#checkStatus, 3000);
    }

    #checkStatus() {
        this.api.reportPDFStatus(true, this.#monitorStatus.bind(this), this.#monitorStatusTimeout.bind(this));
    }

    #hasReportLoaded() {
        return $('.app-project-report-content').length > 0;
    }

    #onReadyToPublish() {
        this.hideDoingWork();
        this.publishModal.open();
    }

    #onConfirmPublish() {
        let permissionToFeature = $('#permission_to_feature').is(':checked');
        let data = {};
        if (permissionToFeature) {
            data = {
                'permission_to_feature': true
            }
        }
        this.api.publishProject(data, this.#onPublishStarted.bind(this));
        this.doDelayed(function () {
            this.showDoingWork('Publishing your project', 'Please wait whilst your submission is finalised.');
            this.publishModal.close();
        }, 500);
    }

    #onPublishStarted(result) {
        this.api.parent.context.project_id = result['project_id'];
        this.#monitorPublishStatus();
    }

    #monitorPublishStatus() {
        this.api.publishStatus(function (result) {
            if (result.published) {
                this.#goToReport(result.report);
            } else {
                this.doDelayed(this.#monitorPublishStatus, 1000);
            }
        }.bind(this));
    }


    #goToReport(reportUrl) {
        window.location.href = reportUrl;
    }
}